export const parseRefundType = (type) => {
  switch (type) {
    case 'refund':
      return 'Rechazo total'
    case 'partial_refund':
      return 'Rechazo parcial'
    default:
      return type || 'N/A'
  }
}
